<div class="step-container">
  <div class="step-header">
    <div class="step-header-icon"><i class="fas fa-lock" aria-hidden="true"></i></div>
    <h2>Cambio de contraseña</h2>
    <p>Nueva contraseña para tu Certifirma Digital Virtual (8 a 12 caracteres, mayúscula, número y carácter especial).</p>
  </div>
  <form [formGroup]="form" (ngSubmit)="ngSubmit()" novalidate>
    <label class="label-document">Nueva contraseña *</label>
    <div class="auth-input-wrap auth-input-wrap-password" [class.is-invalid]="hasError('nueva')">
      <input [type]="showNueva ? 'text' : 'password'" formControlName="nueva" class="auth-input" placeholder="8 a 12 caracteres" [attr.maxlength]="passwordMaxLength" [class.auth-input-masked]="!showNueva">
      <button
        type="button"
        class="password-toggle-btn"
        (mousedown)="showNueva = true"
        (mouseup)="showNueva = false"
        (mouseleave)="showNueva = false"
        (touchstart)="showNueva = true; $event.preventDefault()"
        (touchend)="showNueva = false"
        (touchcancel)="showNueva = false"
        (pointerdown)="showNueva = true"
        (pointerup)="showNueva = false"
        (pointercancel)="showNueva = false"
        tabindex="0"
        [attr.aria-label]="'Mantenga pulsado para ver la contraseña'">
        <i class="fas fa-eye" aria-hidden="true"></i>
      </button>
    </div>
    <div class="invalid-feedback d-block" *ngIf="hasError('nueva')">{{ getErrorMessage('nueva') }}</div>
    <ul class="req-list">
      <li [class.ok]="hasMinLength">8–12 caracteres</li>
      <li [class.ok]="hasUpper">Al menos una mayúscula</li>
      <li [class.ok]="hasNumber">Al menos un número</li>
      <li [class.ok]="hasSpecial">Al menos un carácter especial</li>
    </ul>

    <label class="label-document">Confirmar contraseña *</label>
    <div class="auth-input-wrap auth-input-wrap-password" [class.is-invalid]="hasError('confirmar') || (form.get('confirmar')?.touched && !passwordsMatch())">
      <input [type]="showConfirmar ? 'text' : 'password'" formControlName="confirmar" class="auth-input" placeholder="Repita la contraseña" [attr.maxlength]="passwordMaxLength" [class.auth-input-masked]="!showConfirmar">
      <button
        type="button"
        class="password-toggle-btn"
        (mousedown)="showConfirmar = true"
        (mouseup)="showConfirmar = false"
        (mouseleave)="showConfirmar = false"
        (touchstart)="showConfirmar = true; $event.preventDefault()"
        (touchend)="showConfirmar = false"
        (touchcancel)="showConfirmar = false"
        (pointerdown)="showConfirmar = true"
        (pointerup)="showConfirmar = false"
        (pointercancel)="showConfirmar = false"
        tabindex="0"
        [attr.aria-label]="'Mantenga pulsado para ver la contraseña'">
        <i class="fas fa-eye" aria-hidden="true"></i>
      </button>
    </div>
    <div class="invalid-feedback d-block" *ngIf="hasError('confirmar')">{{ getErrorMessage('confirmar') }}</div>
    <div class="invalid-feedback d-block" *ngIf="form.get('confirmar')?.touched && form.get('confirmar')?.value && !passwordsMatch()">Las contraseñas no coinciden</div>
    <p class="text-ok" *ngIf="passwordsMatch() && form.get('confirmar')?.touched">Las contraseñas coinciden</p>

    <div class="button-container">
      <button type="button" class="btn btn-secondary" (click)="back.emit()">Atrás</button>
      <button type="submit" class="btn btn-primary" [disabled]="form.invalid || !passwordsMatch()">Actualizar contraseña</button>
    </div>
  </form>
</div>
